import {
  Component,
  inject,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { InstituicoesEnsinoCadastrarCursosComponent } from '../instituicoes-ensino-cadastrar-cursos/instituicoes-ensino-cadastrar-cursos.component';
import { InstituicoesEnsinoDetalheCursoComponent } from '../instituicoes-ensino-detalhe-curso/instituicoes-ensino-detalhe-curso.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import {
  CursoService,
  ProgramaService,
  InstituicaoEnsinoService,
  InstituicaoEnsinoCursoService,
  CategoriaInstituicaoEnsinoService,
  AreaProgramaFormacaoService,
  AreaFormacaoService,
  EnumService,
} from '../../../api/services';
import { AccordionModule } from 'primeng/accordion';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { forkJoin, Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {
  TableComponent,
  TableColumn,
} from '@app/shared/components/table/table.component';
import { Pagination } from '@app/shared/model';
import { DrawerModule } from 'primeng/drawer';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { ApiService } from '../../../../../../core/providers/http/api.service';
import { FilterItem } from '../../../api/models/filterItem.model';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { Curso } from '../../../api/models/curso.model';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-instituicoes-ensino-listar-cursos',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SearchBarComponent,
    ToastModule,
    Button,
    ConfirmDialogModule,
    SelectModule,
    DialogModule,
    TableComponent,
    InstituicoesEnsinoDetalheCursoComponent,
    DrawerModule,
    CommonModule,
    DataVoidComponent,
    AccordionModule,
    PaginatorControlComponent,
  ],
  providers: [
    DialogService,
    CursoService,
    ProgramaService,
    InstituicaoEnsinoService,
    InstituicaoEnsinoCursoService,
    MessageService,
    ConfirmationService,
    DynamicDialogConfig,
    DynamicDialogRef,
    ApiService,
    CategoriaInstituicaoEnsinoService,
    AreaProgramaFormacaoService,
    AreaFormacaoService,
    EnumService,
  ],
  templateUrl: './instituicoes-ensino-listar-cursos.component.html',
  styleUrls: ['./instituicoes-ensino-listar-cursos.component.scss'],
  standalone: true,
})
export class InstituicoesEnsinoListarCursosComponent
  implements OnInit, OnDestroy
{
  dialogService = inject(DialogService);
  confirmationService = inject(ConfirmationService);
  messageService = inject(MessageService);
  cursoService = inject(CursoService);
  programaService = inject(ProgramaService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  instituicaoEnsinoCursoService = inject(InstituicaoEnsinoCursoService);
  private categoriaInstituicaoEnsino = inject(
    CategoriaInstituicaoEnsinoService,
  );
  areaProgramaFormacaoService = inject(AreaProgramaFormacaoService);
  areaFormacaoService = inject(AreaFormacaoService);
  enumService = inject(EnumService);
  route = inject(ActivatedRoute);

  isLoading: boolean = false;
  cursos: Curso[] = [];
  private subscriptions = new Subscription();
  pagination: Pagination<any> = new Pagination<any>();
  paginationUnidadeOrganica: Pagination<any> = new Pagination<any>();

  @Output() courseCount: EventEmitter<number> = new EventEmitter<number>();

  nivelAcademicoOptions: any[] = [];
  form!: FormGroup;
  areaFormacaoList: any[] = [];
  categoriaInstituicaoEnsinoList: any[] = [];
  unidade: any;
  activeIndex: number | number[] = -1;
  ShowCursoDetails: boolean = false;
  cursoSelecionado: Curso | null = null;
  showFilter = false;
  unidadeOrganicaID: any;

  constructor(private fb: FormBuilder) {}

  actionOptions: MenuItem[] = [
    {
      label: 'Adicionar plano curricular',
      icon: 'pi pi-plus',
      command: (event) => this.showDetails(event.item?.['data']),
    },
    {
      label: 'Detalhes',
      icon: 'pi pi-info-circle',
      command: (event) => this.showDetails(event.item?.['data']),
    },
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: (event) => this.editCurso(event.item?.['data']),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: (event) => this.deleteCurso(event.item?.['data']),
    },
  ];

  columns: TableColumn[] = [
    { field: 'curso', header: 'Nome do Curso' },
    { field: 'valorMensalidade', header: 'Valor Mensalidade' },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'Designacao',
      placeholder: 'Área de Formação',
      options: this.areaFormacaoList,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'CategoriaEnsinoCursoID',
      placeholder: 'Categoria do curso',
      options: this.categoriaInstituicaoEnsinoList,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  get instituicaoEnsinoID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    this.form = this.fb.group({
      Designacao: [null],
      CategoriaEnsinoCursoID: [null],
    });
    this.loadAllUnidadeOrganica();
    this.loadDadosCombinados();
    // NOTA: loadCursosByInstituicaoEnsino NÃO é chamado aqui.
    // É chamado dentro de loadAllUnidadeOrganica (view simples, sem unidades)
    // ou quando o utilizador abre um tab do accordion (onAccordionTabOpen).
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  // ─── Accordion ───────────────────────────────────────────────────────────────

  /**
   * Chamado pelo (activeIndexChange) do p-accordion.
   * O PrimeNG emite o índice numérico do tab aberto.
   * Sem guard de "mesma unidade" — fechar e reabrir sempre recarrega.
   */
  onActiveIndexChange(index: number | number[] | null) {
    this.activeIndex = index ?? -1;

    // Accordion fechado — limpa estado
    if (index === null || index === -1) {
      this.unidade = null;
      this.pagination = new Pagination<any>();
      return;
    }

    const idx = Array.isArray(index) ? index[0] : index;
    const unidade = this.paginationUnidadeOrganica?.data?.[idx];

    if (!unidade?.id) return;

    // Sempre carrega — sem guard para garantir reload ao reabrir o mesmo accordion
    this.unidade = unidade;
    this.pagination = new Pagination<any>(); // limpa lista anterior
    this.loadCursosByInstituicaoEnsino(this.unidade.id);
    this.unidadeOrganicaID = unidade.id;
  }

  /**
   * Chamado pelo componente pai quando o utilizador muda de tab.
   * Fecha todos os accordions e limpa o estado de cursos para evitar
   * mostrar dados stale ao regressar à tab de cursos.
   */
  resetAccordion(): void {
    this.activeIndex = -1;
    this.unidade = null;
    this.pagination = new Pagination<any>();
  }

  // ─── Carregamento de dados ───────────────────────────────────────────────────

  loadAllUnidadeOrganica(queryParams?: any) {
    const params = {
      ...queryParams,
      pageNumber: this.paginationUnidadeOrganica.pageNumber ?? 1,
      pageSize: this.paginationUnidadeOrganica.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };

    this.instituicaoEnsinoService
      .list({ ...params, InstituicaoPaiID: this.instituicaoEnsinoID })
      .subscribe((res) => {
        this.paginationUnidadeOrganica = res;

        // Se não existem unidades orgânicas, entra na view simples e
        // carrega os cursos directamente da instituição de ensino.
        if (!res?.data?.length) {
          this.loadCursosByInstituicaoEnsino(this.instituicaoEnsinoID);
        }
      });
  }

  loadCursosByInstituicaoEnsino(
    instituicaoEnsinoID?: number,
    queryParams?: any,
  ) {
    const params = {
      ...queryParams,
      InstituicaoEnsinoID: instituicaoEnsinoID,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
    };

    this.subscriptions.add(
      this.instituicaoEnsinoCursoService.list(params).subscribe((cursos) => {
        // Preserva pageNumber/pageSize ao deserializar (caso o backend não os devolva)
        const current = {
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
        };
        this.pagination = new Pagination<Curso>().deserialize(cursos);
        this.pagination.pageNumber ??= current.pageNumber;
        this.pagination.pageSize ??= current.pageSize;
      }),
    );
  }

  loadDadosCombinados() {
    const nivelAcademicoRequest = this.enumService.getAllNivelAcademicoEnum();
    const areaFormacaoRequest = this.areaFormacaoService.list({
      pageSize: 1000,
    });
    const categoriaInstituicaoEnsinoRequest =
      this.categoriaInstituicaoEnsino.list({
        pageSize: 1000,
        OrderBy: 'name desc',
      });
    const cursoServiceRequest = this.cursoService.list({ pageSize: 1000 });

    this.subscriptions.add(
      forkJoin([
        nivelAcademicoRequest,
        areaFormacaoRequest,
        categoriaInstituicaoEnsinoRequest,
        cursoServiceRequest,
      ]).subscribe(
        ([
          nivelAcademicoResponse,
          areaFormacaoResponse,
          categoriaInstituicaoEnsinoResponse,
          cursoServiceResponse,
        ]) => {
          if (nivelAcademicoResponse?.data) {
            this.nivelAcademicoOptions = Object.entries(
              nivelAcademicoResponse.data,
            ).map(([key, value]) => ({ id: Number(key), designacao: value }));
          }

          this.areaFormacaoList = areaFormacaoResponse.data || [];
          this.filters[0].options = this.areaFormacaoList;

          this.categoriaInstituicaoEnsinoList =
            categoriaInstituicaoEnsinoResponse.data || [];
          this.filters[1].options = this.categoriaInstituicaoEnsinoList;

          this.cursos = cursoServiceResponse.data || [];
        },
        (error) => {
          console.error('Erro ao carregar dados:', error);
        },
      ),
    );
  }

  // ─── Acções sobre cursos ─────────────────────────────────────────────────────

  onActionSelected(event: { event: any; rowData: Curso }) {
    const action = event.event.value;
    const curso = event.rowData;
    if (action === 'edit') {
      this.editCurso(curso);
    } else if (action === 'delete') {
      this.deleteCurso(curso);
    }
  }

  editCurso(curso: Curso) {
    const ref = this.dialogService.open(
      InstituicoesEnsinoCadastrarCursosComponent,
      {
        showHeader: false,
        width: '50%',
        modal: true,
        data: {
          areaFormacaoList: this.areaFormacaoList,
          categoriaInstituicaoEnsinoList: this.categoriaInstituicaoEnsinoList,
          nivelAcademicoOptions: this.nivelAcademicoOptions,
          instituicaoEnsinoID: this.instituicaoEnsinoID,
          cursos: this.cursos,
          curso,
        },
      },
    );

    ref.onClose.subscribe((data) => {
      if (data) {
        const payload = {
          id: data.id,
          instituicaoEnsinoID: this.unidadeOrganicaID,
          cursoID: data.cursoID,
          valorMensalidade: data.valorMensalidade,
          IsNewCurse: data.IsNewCurse,
        };
        this.isLoading = true;
        this.instituicaoEnsinoCursoService.update(payload).subscribe(
          () => {
            this.handleSuccess('Curso actualizado com sucesso!');
          },
          (error: any) => {
            this.handleError('Erro ao actualizar curso.', error);
          },
        );
      }
    });
  }

  deleteCurso(curso: Curso) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja eliminar este curso?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Cancelar',
      acceptIcon: 'pi pi-trash',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.instituicaoEnsinoCursoService.delete(curso?.id as any).subscribe(
          () => {
            this.handleSuccess('Curso eliminado com sucesso!');
          },
          (error: any) => {
            this.handleError('Erro ao eliminar curso.', error);
          },
        );
      },
    });
  }

  showDetails(curso: Curso) {
    this.ShowCursoDetails = true;
    this.cursoSelecionado = curso;
  }

  cancel() {
    this.ShowCursoDetails = false;
  }

  showDialog(instituicaoEnsinoID?: number) {
    const ref = this.dialogService.open(
      InstituicoesEnsinoCadastrarCursosComponent,
      {
        showHeader: false,
        width: '50%',
        modal: true,
        data: {
          instituicaoEnsinoID: this.unidadeOrganicaID,
          areaFormacaoList: this.areaFormacaoList,
          categoriaInstituicaoEnsinoList: this.categoriaInstituicaoEnsinoList,
          nivelAcademicoOptions: this.nivelAcademicoOptions,
          unidade: this.unidade,
          cursos: this.cursos,
        },
      },
    );

    ref.onClose.subscribe((data) => {
      if (data) {
        this.isLoading = true;
        if (!data.IsNewCurse) {
          this.addSimpleCurso(data);
        } else {
          this.addCursoWithDetails(data);
        }
      }
    });
  }

  private addSimpleCurso(data: any): void {
    const payload = {
      instituicaoEnsinoID: data.instituicaoEnsinoID || this.instituicaoEnsinoID,
      cursoID: data.cursoID || 0,
      valorMensalidade: data.valorMensalidade || 0,
    };
    this.instituicaoEnsinoCursoService.store(payload).subscribe(
      () => this.handleSuccess('Curso adicionado com sucesso!'),
      (error: any) => this.handleError('Erro ao adicionar curso.', error),
    );
  }

  private addCursoWithDetails(data: any): void {
    const payload = this.buildCursoPayload(data);
    this.instituicaoEnsinoCursoService
      .addCursoInstituicaoEnsino(payload)
      .subscribe(
        () => this.handleSuccess('Curso adicionado com sucesso!'),
        (error: any) => this.handleError('Erro ao adicionar curso.', error),
      );
  }

  private buildCursoPayload(data: any): any {
    return {
      instituicaoEnsinoID: data.instituicaoEnsinoID || this.instituicaoEnsinoID,
      cursoID: data.cursoID || 0,
      curso: {
        designacao: data.designacao || '',
        sigla: data.sigla || '',
        areaFormacaoID: data.areaFormacaoID || 0,
        nivelAcademico: data.nivelAcademico || 0,
        codigo: data.codigo || '',
        categoriaInstituicaoEnsinoID: data.categoriaInstituicaoEnsinoID || 0,
      },
      valorMensalidade: data.valorMensalidade || 0,
    };
  }

  private handleSuccess(message: string): void {
    this.loadCursosByInstituicaoEnsino(
      this.unidade?.id || this.instituicaoEnsinoID,
    );
    this.loadDadosCombinados();
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: message,
    });
    this.isLoading = false;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: message,
    });
    this.isLoading = false;
  }

  // ─── Paginação ───────────────────────────────────────────────────────────────

  onPageChange(event: { first: number; rows: number }) {
    this.pagination.pageNumber = event.first / event.rows + 1;
    this.pagination.pageSize = event.rows;
    this.loadCursosByInstituicaoEnsino(
      this.unidade?.id || this.instituicaoEnsinoID,
    );
  }

  onPageChangeUnidadeOrganica(event: { first: number; rows: number }) {
    this.paginationUnidadeOrganica.pageNumber = event.first / event.rows + 1;
    this.paginationUnidadeOrganica.pageSize = event.rows;
    this.loadAllUnidadeOrganica();
  }

  // ─── Utilitários ─────────────────────────────────────────────────────────────

  trackById(index: number, item: any) {
    return item.id;
  }

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, v]) => v !== null && v !== undefined && v !== '',
      ),
    );
    this.pagination.pageNumber = 1;
    this.loadCursosByInstituicaoEnsino(this.unidade?.id, filters);
    this.showFilter = false;
  }
}
